import {IRoutableModule} from '../../router/routing.infra';
import {ConnectivityCheckView} from './connectivity-check.view';
import {connectivityCheckRouteLoader} from './connectivity-check.loader';

export default {
    loader: connectivityCheckRouteLoader,
    Component: ConnectivityCheckView,
    MobileComponent: ConnectivityCheckView,
    storeAs: 'connectivityCheckStore'
} as IRoutableModule;
